define('gumbo-js-client-lib/forms/gameData/LocationForm',{
	id: null,
	location: null,
	name: null,
	channelLoc: null
});
